import { QueryClient } from "@tanstack/react-query";

import queryCache from "./queryCache";

const queryClient = new QueryClient({ queryCache });

export default queryClient;
